import { useEffect, useState } from 'react';

import { Container, Image } from 'react-bootstrap';

import logo from '../images/logo-pagina-inicial.png'
import logoAbea from '../images/logo-abea.png'
import logoBea from '../images/logo-bea.png'
import logoA2a2 from '../images/logo-a2a2.png'
import logoF4T from '../images/logo-f4t.svg'
import logoRPC from '../images/logo-rpc.png'
import logoPS from '../images/logo-ps.png'
import logoDuroc from '../images/logo-duroc.png'
import logoOvoCaipira from '../images/logo-ovo-caipira.png'
import logoProdutoSustentavel from '../images/logo-produto-sustentavel.png'
import logoConsumoConsciente from '../images/logo-consumo-consciente.png'

import OpcaoMenuInicial from '../components/OpcaoMenuInicial';
import constantes from '../helpers/constanteHelper';

function PaginaInicial() {
    const [width, setWidth] = useState(window.innerWidth);

    function observarMudancaWidth() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', observarMudancaWidth);

        // Scroll para o topo da página para melhor visualização no mobile ou em resoluções menores
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })

        return () => {
            window.removeEventListener('resize', observarMudancaWidth);
        }
    }, []);

    const resolucaoMobile = width <= constantes.RESPONSIVIDADE.LARGURA_MOBILE;

    return (
        <>
            <div className='d-flex flex-column align-items-center justify-content-center' style={{ minHeight: '100vh', background: 'white' }}>
                <Image className='p-3' width={250} src={logo} alt='logo' fluid />
                <span style={{fontSize: '20px'}} className='mb-5'>Selecione a certificação desejada:</span>
                <Container className='animate__animated animate__fadeIn d-flex flex-wrap align-items-center justify-content-center gap-4 mb-5 mt-3'>
                    <OpcaoMenuInicial imagem={logoAbea} cor={'#3D2F66'} resolucaoMobile={resolucaoMobile} path={'/catalogo-abea/sobre'} />
                    <OpcaoMenuInicial imagem={logoA2a2} cor={'#29518D'} resolucaoMobile={resolucaoMobile} path={'/catalogo-a2a2/sobre'} />
                    <OpcaoMenuInicial imagem={logoBea} cor={'#CD5A1C'} resolucaoMobile={resolucaoMobile} path={'/catalogo-bea/sobre'} />
                    <OpcaoMenuInicial imagem={logoF4T} cor={'#8E008C'} resolucaoMobile={resolucaoMobile} path={'/catalogo-fair4them/sobre'} />
                    <OpcaoMenuInicial imagem={logoRPC} cor={'#ACC435'} resolucaoMobile={resolucaoMobile} path={'/catalogo-rpc/sobre'} />
                    <OpcaoMenuInicial imagem={logoPS} cor={constantes.CORES.VERDE_PRODUCAO_SUSTENTAVEL} resolucaoMobile={resolucaoMobile} path={'/catalogo-ps/sobre'} />
                    <OpcaoMenuInicial imagem={logoDuroc} cor={constantes.CORES.DOURADO_DUROC} resolucaoMobile={resolucaoMobile} path={'/catalogo-duroc/sobre'} />
                    <OpcaoMenuInicial imagem={logoOvoCaipira} cor={constantes.CORES.MARROM_OVO_CAIPIRA} resolucaoMobile={resolucaoMobile} path={'/catalogo-ovo-caipira/sobre'} />
                    <OpcaoMenuInicial imagem={logoProdutoSustentavel} cor={constantes.CORES.VERDE_PRODUTO_SUSTENTAVEL} resolucaoMobile={resolucaoMobile} path={'/catalogo-produto-sustentavel/sobre'} />
                    <OpcaoMenuInicial imagem={logoConsumoConsciente} cor={constantes.CORES.COR_CONSUMO_CONSCIENTE} resolucaoMobile={resolucaoMobile} path={'/catalogo-consumo-consciente/sobre'} />
                </Container>
            </div>
        </>
    );
}

export default PaginaInicial;
